<rfid-manager>
  <div class="rfid-manager">
    <!-- Page Header -->
    <page-header
      title="Gestión de Tarjetas RFID"
      subtitle={state.isAdmin
        ? 'Administra las tarjetas RFID de todos los usuarios y visualiza el historial de accesos'
        : 'Administra tus tarjetas RFID y visualiza el historial de accesos'}
      onback={ handleGoBack }>
    </page-header>

    <!-- Tabs navigation -->
    <ul class="nav nav-tabs mb-4" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class={'nav-link ' + (state.activeTab === 'cards' ? 'active' : '')}
          type="button"
          onclick={() => setActiveTab('cards')}
        >
          <i class="bi bi-credit-card me-1"></i>
          Tarjetas
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class={'nav-link ' + (state.activeTab === 'access-log' ? 'active' : '')}
          type="button"
          onclick={() => setActiveTab('access-log')}
        >
          <i class="bi bi-clock-history me-1"></i>
          Historial de Accesos
        </button>
      </li>
    </ul>

    <!-- Tab content -->
    <div class="tab-content">
      <!-- Cards tab -->
      <div if={state.activeTab === 'cards'} class="tab-pane fade show active">
        <rfid-card-manager userId={state.userId} isAdmin={state.isAdmin} isOwnProfile={!state.isAdmin} />
      </div>

      <!-- Access log tab -->
      <div if={state.activeTab === 'access-log'} class="tab-pane fade show active">
        <rfid-access-log userId={state.userId} />
      </div>
    </div>
  </div>

  <script>
    import PageHeader from './page-header.riot';
    import { AuthService } from '../services/api-service';
    import RfidCardManager from './rfid-card-manager.riot';
    import RfidAccessLog from './rfid-access-log.riot';

    export default {
      components: {
        PageHeader,
        RfidCardManager,
        RfidAccessLog
      },

      state: {
        activeTab: 'cards',
        userId: '',
        isAdmin: false
      },

      onMounted() {
        this.loadUserData();
      },

      isAdmin() {
        return AuthService.isAdmin();
      },

      setActiveTab(tab) {
        this.update({ activeTab: tab });
      },

      async loadUserData() {
        const userData = await AuthService.getCurrentUser();
        if (userData) {
          this.update({
            userId: userData.id || userData._id,
            isAdmin: AuthService.isAdmin()
          });
        }
      },

      handleGoBack() {
        if (this.props.onback) {
          this.props.onback();
        } else {
          window.history.pushState({}, '', '/');
          window.dispatchEvent(new PopStateEvent('popstate'));
        }
      }
    }
  </script>

  <style>
    .rfid-manager .nav-tabs {
      border-bottom: 2px solid #dee2e6;
    }

    .rfid-manager .nav-tabs .nav-link {
      border: none;
      color: #6c757d;
      padding: 0.75rem 1rem;
    }

    .rfid-manager .nav-tabs .nav-link:hover {
      border: none;
      color: #0d6efd;
    }

    .rfid-manager .nav-tabs .nav-link.active {
      color: #0d6efd;
      border-bottom: 3px solid #0d6efd;
      font-weight: 500;
    }
  </style>
</rfid-manager>
